/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, message, notification, Row, Col, Form, Radio, Space, Checkbox, Select } from 'antd';
import testAlert from "../../common/helpers/test-alert";
import createAlert from "../../common/helpers/create-alert";
import { useAppContext, APP_ACTIONS } from "../../../context/appContext";
import fetchBots from "../../common/helpers/fetch-bots";
import { CloseOutlined } from '@ant-design/icons';
const { TextArea } = Input;
const AddAlert = ({ displayAddAlert, setDisplayAddAlert, onChangeAlert, selectedBot }) => {
    const {
        state: { bots },
        dispatch,
    } = useAppContext();

    const foundAlert = bots.find(bot => bot.id === selectedBot.id).alert;
    const [step, setStep] = useState(0);
    const [options, setOptions] = useState([]);
    const [telegramBot, setTelegramBot] = useState({
        name: 'telegram',
        token: null,
        chat_id: null,
        username: null
    });
    const [slackBot, setSlackBot] = useState({
        name: 'slack',
        webhook_url: null,
    });

    useEffect(() => {
        if (foundAlert) {
            // const parsed = JSON.parse(foundAlert);
            const parsed = foundAlert

            if (parsed.telegram) {
                setTelegramBot({ ...telegramBot, token: parsed.telegram.token, chat_id: parsed.telegram.chat_id, username: parsed.telegram.username })
                setOptions(parsed?.telegram?.options);
            }
            if (parsed.slack) {
                setSlackBot({ ...slackBot, webhook_url: parsed.slack.webhook_url })
            }
        }
    }, [foundAlert])

    const goBack = () => {
        if (step !== 0) {
            setStep(step - 1);
        } else {
            setDisplayAddAlert(false);
            // onChangeAlert(rebalance, rebalanceSymbol)
        }
    }
    const onClickNext = () => {
        if (step === 1) {
            telegramConnect();
        }
        if (step !== 2) {
            setStep(step + 1);
        } else {
            telegramBot.options = options;

            if (telegramBot.token) {
                if (!telegramBot.chat_id || !telegramBot.username) {
                    message.error('Please enter your telegram credentials')
                    return;
                }
            }
            slackBot.options = options;
            createAlert({ bot: { telegram: telegramBot, slack: slackBot }, id: selectedBot.id }).then(res => {
                fetchBots().then(res => {
                    dispatch({
                        type: APP_ACTIONS.SET_BOTS,
                        payload: res,
                    })
                })

                if (res.error) {
                    message.error({ content: res.error });
                } else {
                    message.success({ content: 'Changes Saved' });
                }
            })
            setDisplayAddAlert(false);

            // onChangeAlert(rebalance, rebalanceSymbol)
        }
    }
    const handleConnect = () => {
        setStep(1);
    }

    const handleOptions = (checked, option) => {
        if (checked) {
            let newOptions = [...options];
            newOptions.push(option);

            setOptions(newOptions);
        } else {
            let newOptions = [...options];
            const index = newOptions.indexOf(option);
            newOptions.splice(index, 1);
            setOptions(newOptions);
        }
    }
    const telegramConnect = () => {
        if (telegramBot.token) {
            if (!telegramBot.username || !telegramBot.chat_id) {
                message.error('Please enter your telegram credentials')
            } else {
                testAlert(telegramBot).then(res => {
                    if (res.error) {
                        message.error({ content: res.error });
                    }
                })
            }

        }
        if (slackBot.webhook_url) {
            testAlert(slackBot).then(res => {
                if (res.error) {
                    message.error({ content: res.error });
                }
            })
        }

        // if (telegramBot.chat_id || slackBot.webhook_url) {
        //     onClickNext();
        // }
    }
    const renderSteps = () => {
        if (step === 0) {
            return <>
                <div style={{ fontWeight: "600", color: "white" }}>
                    <svg style={{ position: "relative", top: 4, marginRight: 5 }} xmlns="http://www.w3.org/2000/svg" width="23.427" height="23.999" viewBox="0 0 27.427 27.999">
                        <path id="Path_6010" data-name="Path 6010" d="M241.939,159.156c-1.818-3.147-4.09-4.879-6.4-4.879s-4.581,1.733-6.4,4.879a17.9,17.9,0,0,0-2.449,8.171,8.819,8.819,0,0,0,2.669,6.32c-.942.365-1.5.815-1.5,1.3,0,1.216,3.44,2.2,7.683,2.2s7.683-.988,7.683-2.2c0-.489-.563-.94-1.5-1.3a8.815,8.815,0,0,0,2.669-6.32,17.868,17.868,0,0,0-2.447-8.171Zm-6.4,15.221a7.058,7.058,0,0,1-7.05-7.05c0-4.233,3.415-11.254,7.05-11.254s7.05,7.021,7.05,11.254A7.058,7.058,0,0,1,235.54,174.377Zm.34-9.34a3.2,3.2,0,0,1-1.008-.586,1,1,0,0,1-.263-.726,1.157,1.157,0,0,1,.248-.779,1.2,1.2,0,0,1,1.622.055,1.5,1.5,0,0,1,.293.99h1.684l.012-.029a2.509,2.509,0,0,0-.586-1.775,2.607,2.607,0,0,0-1.664-.83v-1.282h-.94v1.263a2.81,2.81,0,0,0-1.748.748,2.45,2.45,0,0,0,0,3.311,5.511,5.511,0,0,0,1.979,1.046,2.74,2.74,0,0,1,.987.563,1.087,1.087,0,0,1,.278.778,1.044,1.044,0,0,1-.289.775,1.2,1.2,0,0,1-.868.282,1.409,1.409,0,0,1-.959-.322,1.364,1.364,0,0,1-.37-1.078H232.61l-.018.036a2.38,2.38,0,0,0,.705,1.918,3.142,3.142,0,0,0,1.864.753v1.162h.94v-1.162a2.853,2.853,0,0,0,1.751-.731,2.178,2.178,0,0,0,.641-1.643,2.226,2.226,0,0,0-.649-1.693,5.178,5.178,0,0,0-1.964-1.043Zm-.34-12.213a.9.9,0,0,0,.9-.9v-1.869a.9.9,0,1,0-1.8,0v1.869A.9.9,0,0,0,235.54,152.824Zm-8.837,5.147a.9.9,0,1,0,1.271-1.272l-1.322-1.321a.9.9,0,0,0-1.271,1.272Zm17.039.262a.9.9,0,0,0,.636-.262l1.322-1.322a.9.9,0,0,0-1.271-1.271l-1.322,1.322a.9.9,0,0,0,.635,1.534Zm-19.147,6.56h-1.869a.9.9,0,0,0,0,1.8h1.869a.9.9,0,0,0,0-1.8Zm23.761,0h-1.869a.9.9,0,1,0,0,1.8h1.869a.9.9,0,1,0,0-1.8Z" transform="translate(-221.828 -149.157)" fill="#fff" />
                    </svg>
                    Type of alerts</div>
                <div style={{ color: "grey", marginTop: 10 }}>Set the type of alerts you'd like to get</div>
                <div style={{ color: "white", marginTop: 20, marginBottom: 40 }}>
                    <div><Checkbox checked={options?.indexOf('orders') !== -1 ? true : false} style={{ color: "white", marginBottom: 10 }} onChange={(e) => {
                        handleOptions(e.target.checked, 'orders')
                    }}>Orders</Checkbox></div>
                    <div><Checkbox checked={options?.indexOf('filled_trades') !== -1 ? true : false} style={{ color: "white", marginBottom: 10 }} onChange={(e) => {
                        handleOptions(e.target.checked, 'filled_trades')
                    }} >Filled trades</Checkbox></div>
                    <div><Checkbox checked={options?.indexOf('low_balance') !== -1 ? true : false} style={{ color: "white", marginBottom: 10 }} onChange={(e) => {
                        handleOptions(e.target.checked, 'low_balance')
                    }} >Low balance</Checkbox></div>
                </div>
            </>
        } else if (step === 1) {
            return <>
                <div style={{ fontWeight: "600", color: "white" }}>
                    <svg style={{ position: "relative", top: 3, marginRight: 5 }} xmlns="http://www.w3.org/2000/svg" width="19.953" height="16.685" viewBox="0 0 19.953 16.685">
                        <path id="Path_5818" data-name="Path 5818" d="M231.038,168.2h-5.46v-2.46a1.862,1.862,0,0,0-1.766-1.942h-9.2a1.862,1.862,0,0,0-1.766,1.942v6.142a1.862,1.862,0,0,0,1.766,1.942h.538v1.652a.611.611,0,0,0,.974.492l2.9-2.144h1.044v2.46a1.862,1.862,0,0,0,1.766,1.942h4.672l2.9,2.137a.611.611,0,0,0,.974-.492v-1.646h.651a1.862,1.862,0,0,0,1.766-1.942v-6.142a1.862,1.862,0,0,0-1.766-1.942Zm-12.206,4.4a.613.613,0,0,0-.363.119l-2.091,1.544V173.21a.611.611,0,0,0-.611-.611h-1.15c-.294,0-.543-.33-.543-.72v-6.142c0-.39.249-.72.543-.72h9.2c.295,0,.544.33.544.72v2.46h-2.512a1.862,1.862,0,0,0-1.766,1.942v2.46h-1.246Zm12.749,3.682c0,.39-.249.72-.543.72h-1.262a.611.611,0,0,0-.611.611v1.047l-2.087-1.539a.613.613,0,0,0-.363-.119h-4.873c-.294,0-.543-.33-.543-.72v-6.142c0-.39.249-.72.543-.72h9.2c.294,0,.543.33.543.72Z" transform="translate(-212.851 -163.795)" fill="#fff" />
                    </svg>
                    Enter credantials</div>
                <div style={{ border: "1px solid grey", height: 320, width: "100%", marginTop: 30, marginBottom: 30 }}>
                    <h1 style={{ width: 80, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: 5, backgroundColor: "black", color: "white" }}>
                        <svg style={{ position: "relative", top: 3, marginRight: 5 }} xmlns="http://www.w3.org/2000/svg" width="15.572" height="15.57" viewBox="0 0 21.572 21.57">
                            <path id="Path_6011" data-name="Path 6011" d="M264.181,182.677l-8.246,10.463,6.083,6.082,7.19-21.57-21.572,7.191,6.083,6.082Z" transform="translate(-247.635 -177.652)" fill="#fff" />
                        </svg>
                        Telegram</h1>
                    <span style={{}}>
                        <div style={{ padding: "0 20px" }}>
                            <div style={{ color: "white", marginTop: 10 }}>
                                <label>Your Telegram Token</label>
                                <Input onChange={(e) => { setTelegramBot({ ...telegramBot, token: e.target.value }) }} value={telegramBot.token} style={{ marginTop: 10 }} placeholder="Input Telegram Token" />
                            </div>
                            <div style={{ color: "white", marginTop: 10 }}>
                                <label>Chat Id</label>
                                <Input onChange={(e) => { setTelegramBot({ ...telegramBot, chat_id: e.target.value }) }} value={telegramBot.chat_id} style={{ marginTop: 10 }} placeholder="Input Chat Id" />
                            </div>
                            <div style={{ color: "white", marginTop: 10 }}>
                                <label>Telegram Username(s)</label>

                                <Select
                                    mode="tags"
                                    style={{
                                        width: '100%',
                                        marginTop: 10
                                    }}
                                    value={telegramBot.username}
                                    notFoundContent={false}
                                    placeholder="Add usernames"
                                    onChange={(value) => { setTelegramBot({ ...telegramBot, username: value }) }}
                                >
                                </Select>


                                {/* <Input onChange={(e) => { setTelegramBot({ ...telegramBot, username: e.target.value }) }} value={telegramBot.username} style={{ marginTop: 10 }} placeholder="Input your username" /> */}
                            </div>
                            <div onClick={() => { telegramConnect() }} style={{ color: "white", cursor: "pointer", display: "flex", justifyContent: "flex-end", flexDirection: "row", padding: "10px 0" }}>
                                {/* <span style={{ textDecoration: "underline" }} >CONNECT</span> */}
                            </div>
                            <div style={{ color: "white" }}>You can find your chat_id with: https://api.telegram.org/bot{`<YOURTOKEN>`}/getUpdates</div>
                        </div>

                    </span>
                </div>

                <div style={{ border: "1px solid grey", height: 200, width: "100%", marginTop: 30 }}>
                    <h1 style={{ width: 63, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: 5, backgroundColor: "black", color: "white" }}>
                        <svg style={{ position: "relative", top: 3, marginRight: 5 }} xmlns="http://www.w3.org/2000/svg" width="15.57" height="15.57" viewBox="0 0 21.57 21.57">
                            <path id="slack_black_logo_icon_147081" d="M10.458,19.557a2.266,2.266,0,1,1-2.266-2.266h2.266Zm3.408-2.266A2.271,2.271,0,0,0,11.6,19.557v5.674a2.266,2.266,0,0,0,4.532,0V19.557A2.272,2.272,0,0,0,13.866,17.291Zm0-6.833a2.266,2.266,0,1,1,2.266-2.266v2.266Zm2.266,3.408A2.271,2.271,0,0,0,13.866,11.6H8.193a2.266,2.266,0,0,0,0,4.532h5.674A2.272,2.272,0,0,0,16.132,13.866Zm6.833,0a2.266,2.266,0,1,1,2.266,2.266H22.965Zm-3.408,2.266a2.271,2.271,0,0,0,2.266-2.266V8.193a2.266,2.266,0,0,0-4.532,0v5.674A2.272,2.272,0,0,0,19.557,16.132Zm0,6.833a2.266,2.266,0,1,1-2.266,2.266V22.965Zm-2.266-3.408a2.271,2.271,0,0,0,2.266,2.266h5.674a2.266,2.266,0,0,0,0-4.532H19.557A2.272,2.272,0,0,0,17.291,19.557Z" transform="translate(-5.927 -5.927)" fill="#fff" fill-rule="evenodd" />
                        </svg>
                        Slack</h1>
                    <span style={{}}>
                        <div style={{ padding: "0 20px" }}>
                            <div style={{ color: "white", marginTop: 20 }}>
                                <label>Your Web Hook URL:</label>
                                <Input value={slackBot.webhook_url} onChange={(e) => { setSlackBot({ ...slackBot, webhook_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Web hook URL" />
                            </div>

                            <div onClick={() => { telegramConnect() }} style={{ color: "white", cursor: "pointer", display: "flex", justifyContent: "flex-end", flexDirection: "row", padding: "10px 0" }}>
                                {/* <span style={{ textDecoration: "underline" }} >CONNECT</span> */}
                            </div>
                            <div style={{ color: "white" }}>You can get your slack webhook url from here: https://api.slack.com/</div>
                        </div>

                    </span>
                </div>
            </>
        }
        else if (step === 2) {
            return <>
                <div style={{ fontWeight: "600", color: "white" }}>Enter credantials</div>
                <div style={{ border: "1px solid grey", height: 200, width: "100%", marginTop: 30, marginBottom: 30 }}>
                    <h1 style={{ width: 75, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: 5, backgroundColor: "black", color: "white" }}>Telegram</h1>
                    <span style={{}}>
                        <div style={{ padding: "0 20px" }}>
                            <div style={{ color: "white", marginTop: 10 }}>
                                <div>Your Telegram Token</div>
                                <div>{telegramBot.token || '-'}</div>
                            </div>
                            <div style={{ color: "white", marginTop: 10 }}>
                                <div>Chat Id</div>
                                <div>{telegramBot.chat_id || '-'}</div>
                            </div>

                            <div style={{ color: "white", marginTop: 10 }}>
                                <div>Username</div>
                                <div>{telegramBot.username || '-'}</div>
                            </div>

                            <div style={{ color: "white", cursor: "pointer", display: "flex", justifyContent: "flex-end", flexDirection: "row", padding: "10px 0" }}>
                            </div>
                        </div>
                    </span>
                </div>
                <div style={{ border: "1px solid grey", height: 125, width: "100%", marginTop: 30, marginBottom: 20 }}>
                    <h1 style={{ width: 63, textAlign: "center", fontSize: 14, marginTop: -10, marginLeft: 5, backgroundColor: "black", color: "white" }}>Slack</h1>
                    <span style={{}}>
                        <div style={{ padding: "0 20px" }}>
                            <div style={{ color: "white", marginTop: 20 }}>
                                <div>Your Web Hook URL</div>
                                <div>{slackBot.webhook_url || '-'}</div>
                            </div>

                            <div style={{ color: "white", cursor: "pointer", display: "flex", justifyContent: "flex-end", flexDirection: "row", padding: "10px 0" }}>
                            </div>
                        </div>

                    </span>
                </div>
            </>
        }
    }

    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displayAddAlert} footer={null} onCancel={() => { setDisplayAddAlert(false); }}>

            {renderSteps()}

            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button
                    // disabled={step == 1} 
                    onClick={() => { onClickNext() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">Next</Button>
            </div>
        </Modal>
    );
};

export default AddAlert;